export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-600 via-primary-700 to-accent-700 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/3 -translate-x-1/4"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="flex-1 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-mail-send-line text-2xl text-background-50"></i>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                  爆料投稿 / 商务合作
                </h2>
              </div>
              <p className="text-background-50/80 text-sm md:text-base max-w-[600px] mx-auto md:mx-0">
                你有独家猛料？想与我们合作？欢迎通过以下方式联系我们。重大独家爆料一经采用，提供丰厚稿酬。
                我们承诺对投稿人信息严格保密。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50/15 backdrop-blur-sm rounded-lg">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-mail-line text-background-50"></i>
                </div>
                <span className="text-background-50 text-sm font-medium whitespace-nowrap">tougao@heiliao.com</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50/15 backdrop-blur-sm rounded-lg">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-wechat-line text-background-50"></i>
                </div>
                <span className="text-background-50 text-sm font-medium whitespace-nowrap">heiliao_official</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}